import { connect, MapDispatchToProps } from 'react-redux';
import { batchDoDelete, cancelBatchAction } from '../../../../actions/studio';
import { Props } from './BatchActionLayout';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'batchDoDelete' | 'cancelBatchAction'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  batchDoDelete,
  cancelBatchAction,
};

export default connect(null, mapDispatchToProps);
